export default __webpack_public_path__ + "static/media/marker-place-visible.bc9c8913.png";